<template>
  <BaseWidget
    :class="['rabo-finance']"
    :loading="loading"
    :widget-options="widgetMenuOptions" 
    @refresh-data="refreshData"
    @custom-remove="removeWidget"
    v-on="$listeners"
  >
    <template v-slot:header>
      <div class="title">
        <span class="title-icon">
        </span>
        <h4>{{ $gettext('Apply for a business loan') }}</h4>
      </div>
      <div class="description">{{ $gettext('Use your account to apply for a Rabo Business loan') }}</div>
    </template>
    <template v-slot:content>
      <div @click="manualFinanceToggle" class="rabo-finance-wrap">
        <b-alert show class="gk-alert mb-0" variant="info">
          <div @click="manualFinanceToggle" class="cursor-pointer">
            <!-- <h4>{{ $gettext('Apply for a business loan') }}</h4> -->
            <div class="banner-content">
              <ul>
                <li>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.88586 2.01299C5.03561 2.01299 1.91436 5.13424 1.91436 8.98449C1.91436 12.8347 5.03561 15.956 8.88586 15.956C12.7361 15.956 15.8574 12.8347 15.8574 8.98449C15.8574 8.03326 15.6672 7.12792 15.3233 6.30331L16.3957 5.85609C16.7976 6.81989 17.0193 7.87704 17.0193 8.98449C17.0193 13.4765 13.3778 17.1179 8.88586 17.1179C4.3939 17.1179 0.752441 13.4765 0.752441 8.98449C0.752441 4.49253 4.3939 0.851074 8.88586 0.851074C11.1242 0.851074 13.1523 1.75602 14.6224 3.21864C14.8242 3.41944 14.8508 3.73692 14.6851 3.96848L8.77742 12.2273C8.6781 12.3661 8.52275 12.4543 8.35262 12.4683C8.18249 12.4823 8.01481 12.4208 7.8941 12.3001L4.98931 9.39529L5.81091 8.57369L8.23111 10.9939L13.4427 3.70823C12.2203 2.65147 10.6281 2.01299 8.88586 2.01299Z"
                      fill="#00AF89"
                    />
                  </svg>
                  <span>{{ $gettext('Amounts between Є5.000 and Є250.000') }}</span>
                </li>
                <li>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.88586 2.01299C5.03561 2.01299 1.91436 5.13424 1.91436 8.98449C1.91436 12.8347 5.03561 15.956 8.88586 15.956C12.7361 15.956 15.8574 12.8347 15.8574 8.98449C15.8574 8.03326 15.6672 7.12792 15.3233 6.30331L16.3957 5.85609C16.7976 6.81989 17.0193 7.87704 17.0193 8.98449C17.0193 13.4765 13.3778 17.1179 8.88586 17.1179C4.3939 17.1179 0.752441 13.4765 0.752441 8.98449C0.752441 4.49253 4.3939 0.851074 8.88586 0.851074C11.1242 0.851074 13.1523 1.75602 14.6224 3.21864C14.8242 3.41944 14.8508 3.73692 14.6851 3.96848L8.77742 12.2273C8.6781 12.3661 8.52275 12.4543 8.35262 12.4683C8.18249 12.4823 8.01481 12.4208 7.8941 12.3001L4.98931 9.39529L5.81091 8.57369L8.23111 10.9939L13.4427 3.70823C12.2203 2.65147 10.6281 2.01299 8.88586 2.01299Z"
                      fill="#00AF89"
                    />
                  </svg>
                  <span>{{ $gettext('Interest between 5% and 12%') }}</span>
                </li>
                <li>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.88586 2.01299C5.03561 2.01299 1.91436 5.13424 1.91436 8.98449C1.91436 12.8347 5.03561 15.956 8.88586 15.956C12.7361 15.956 15.8574 12.8347 15.8574 8.98449C15.8574 8.03326 15.6672 7.12792 15.3233 6.30331L16.3957 5.85609C16.7976 6.81989 17.0193 7.87704 17.0193 8.98449C17.0193 13.4765 13.3778 17.1179 8.88586 17.1179C4.3939 17.1179 0.752441 13.4765 0.752441 8.98449C0.752441 4.49253 4.3939 0.851074 8.88586 0.851074C11.1242 0.851074 13.1523 1.75602 14.6224 3.21864C14.8242 3.41944 14.8508 3.73692 14.6851 3.96848L8.77742 12.2273C8.6781 12.3661 8.52275 12.4543 8.35262 12.4683C8.18249 12.4823 8.01481 12.4208 7.8941 12.3001L4.98931 9.39529L5.81091 8.57369L8.23111 10.9939L13.4427 3.70823C12.2203 2.65147 10.6281 2.01299 8.88586 2.01299Z"
                      fill="#00AF89"
                    />
                  </svg>
                  <span>{{ $gettext('2 minutes to apply and an offer within 24 hours') }}</span>
                </li>
              </ul>
            </div>
            <div class="rabo-button-wrap">
              <GekkoButton @click="manualFinanceToggle" :text="$gettext('Request financing')" class="rabo-btn" />
              <div class="rabo-logo">
                <img src="/static/img/third-party/rabobank-text-logo.png" />
              </div>
            </div>
          </div>
        </b-alert>
      </div>
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseWidget from '@/components/dashboard/widgets/BaseWidget'
import GekkoButton from '@/components/GekkoButton'

export default {
  name: 'rabo-finance-widget',
  components: {
    BaseWidget,
    GekkoButton,
  },
  props: {
    widget: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      config: { status: '' },
      filters: {},
    }
  },
  computed: {
    ...mapGetters({
      extraConfig: 'dashboard/getExtraConfig'
    }),
    widgetMenuOptions () {
      if (this.loading) return []
      return [
        { name: this.$gettext('Remove From Dashboard'), icon: 'icon-remove', event: { name: 'custom-remove' } }
      ]
    },
  },
  created() {},
  mounted() {
    this.setupWidget()
  },
  methods: {
    ...mapActions({
      updateExtraConfig: 'dashboard/updateExtraConfig'
    }),
    ...mapMutations({
      toggleFinancingModal: 'dashboard/TOGGLE_FINANCING_MODAL',
    }),
    refreshData() {
      this.getData()
    },
    updateFilters(status) {
      this.filters.status = status === 'all' ? '' : status
      this.setFilters(status)
    },
    getData() {
      this.loading = true
      this.loading = false
    },
    setupWidget() {
      this.title = this.$gettext('Rabobank Financing')
      this.getData() // TODO remove this? right now just triggers a fake loading
      const new_extra_config = this.extraConfig
      new_extra_config.closed_pbl = false
      this.updateExtraConfig(new_extra_config)
    },
    removeWidget () {
      const new_extra_config = this.extraConfig
      new_extra_config.closed_pbl = true
      this.updateExtraConfig(new_extra_config)
      this.$emit('widget-event', { 'event': 'remove' })
    },
    manualFinanceToggle() {
      this.toggleFinancingModal(true)
    },
  },
}
</script>

<style lang="scss">
.rabo-finance {
  .title {
    h4 {
      font-family: MyriadPro, sans-serif;
      // margin-top: 0 !important;
      // margin-bottom: 1.5rem !important;
      color: #0058ff;
      font-style: italic;
      font-size: 20px;
      // line-height: 28.8px;
    }
  }
  .rabo-finance-wrap {
    font-family: MyriadPro, sans-serif;
    -webkit-font-smoothing: antialiased;
    width: 100%;
    display: flex;
    align-items: flex-end;
    .gk-alert {
      padding: 0rem;
      font-size: 14px;
      border: none;
      background: white;
      h4 {
        font-family: MyriadPro, sans-serif;
        margin-top: 0 !important;
        margin-bottom: 1.5rem !important;
        color: #0058ff;
        font-style: italic;
        font-size: 24px;
        line-height: 28.8px;
      }
      .banner-content {
        color: #737578;
        margin-bottom: 1.5rem;
        ul {
          margin: 0;
          padding: 0;
          li {
            display: flex;
            margin-bottom: 0.25rem;
            gap: 0.25rem;
            margin-right: 0.5rem;
            svg {
              height: 22px;
              width: 22px;
            }
            span {
            }
          }
        }
      }
    }
    .rabo-button-wrap {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      gap: 1rem;

      .rabo-btn {
        background: #ff6700;
        border: 1px solid transparent;
        border-radius: 4px;
        padding: 12px 24px;
        font-size: 19px;
        line-height: 1;
        font-family: MyriadPro, sans-serif;
        font-weight: bold;
        transition-duration: 0.4s;
        transition-property: color, background-color, border;
        transition-timing-function: cubic-bezier(0.5, 1, 0.89, 1);
        height: 48px;
        width: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-font-smoothing: antialiased;
        &:hover {
          transition: none;
          background-color: rgb(255, 133, 51);
        }
      }
      .rabo-logo {
        flex: 1;
        text-align: center;
        width: 100%;
        img {
          width: 70px;
        }
      }
    }
  }
}
</style>
